<div class="footer-newsletter">
    <h5 class="footer-newsletter__title">{{ 'newsletter-title' | t:'Style Secrets Unveiled - Get Insider Access!' }}</h5>
    <div class="footer-newsletter__text">
        {{ 'primehat-newsletter-text' | t:'Be the First to Know: Subscribe to PrimeHat\'s Insider Updates for Exclusive Home Decor, Gift Ideas, Car Accessories and More!' }}
    </div>

    <form class="footer-newsletter__form" novalidate (ngSubmit)="submit()">
        <label class="sr-only" for="footer-newsletter-address">{{ 'newsletter-email' | t:'Email Address' }}</label>
        <input [formControl]="emailControl" type="email" inputmode="email" autocomplete="email" maxlength="254" class="footer-newsletter__form-input form-control" id="footer-newsletter-address"
            [attr.placeholder]="'newsletter-email-placeholder' | t:'Email Address...'" (input)="invalidEmail = false">
        <button type="submit" class="footer-newsletter__form-button btn btn-primary"
        [ngClass]="{'btn-loading': calling}" [disabled]="calling">{{ 'subscribe' | t:'Subscribe' }}</button>
    </form>
    <div class="text-danger" role="alert" *ngIf="emailControl.hasError('required') && emailControl.touched"><small>{{ 'email-required' | t:'Email is required' }}</small></div>
    <div class="text-danger" role="alert" *ngIf="invalidEmail && !emailControl.hasError('required')"><small>{{ 'email-invalid' | t:'Email is invalid' }}</small></div>

    <!-- Shown once there are profiles to follow (social-links.component.ts, TODO(operator)). -->
    <div class="footer-newsletter__text footer-newsletter__text--social" *ngIf="hasSocialLinks">
        {{ 'follow-us' | t:'Follow us on social networks' }}
    </div>

    <app-social-links class="footer-newsletter__social-links" shape="circle"></app-social-links>
</div>
